import { Pipe } from '@angular/core';

@Pipe({
  name: 'middleEllipsis',
  standalone: true
})
export class MiddleEllipsisPipe {
  transform(val, maxLength, beforeDots, afterDots) {
    if (maxLength === undefined || beforeDots === undefined || afterDots === undefined) {
      return val;
    }
    if (val && val.length > maxLength) {
      val = val.substr(0, beforeDots) + '...' + val.slice(-afterDots);
    }
    return val;
  }
}
